import l10n from '../../shared/strings';

const { TOAST } = l10n;

export default function buildBatchImportToastMessage({ outcomeLabel, summary, error } = {}) {
  if (error && !summary) {
    return TOAST.BATCH_IMPORT_FAILED_JOB(error);
  }

  const total = summary?.total ?? 0;
  const created = summary?.created ?? 0;
  const updated = summary?.updated ?? 0;
  const errors = summary?.errors ?? 0;

  if (outcomeLabel === 'Failed' || (errors === total && total > 0)) {
    return TOAST.BATCH_IMPORT_FAILED({ total, created, updated, errors });
  }

  if (outcomeLabel === 'Partial' || (errors > 0 && errors < total)) {
    return TOAST.BATCH_IMPORT_PARTIAL({ total, created, updated, errors });
  }

  return TOAST.BATCH_IMPORT_SUCCESS({ total, created, updated });
}
